export default function Reducer(state, action) {
  switch (action.type) {
    case 'LOAD':
      return {
        ...state,
        affiliates: action.affiliates,
      };

    case 'UPDATE':
      return {
        ...state,
        affiliates: state.affiliates.map(
          (item) => item.id === action.affiliate.id ? action.affiliate : item,
        ),
      };

    case 'DELETE':
      return {
        ...state,
        affiliates: state.affiliates.filter(
          (item) => parseInt(item.id, 10) !== parseInt(action.affiliateId, 10),
        ),
      };

    default:
      throw Error(`Unknown action: ${action.type}`);
  }
}
